import React, { useEffect, useState, useRef } from 'react';
import { socket } from './socket.ts';
import ChatSidebar from './components/ChatSidebar.tsx';
import ChatWindow from './components/ChatWindow.tsx';
import './App.css';

const App = () => {
  const [users, setUsers] = useState([]);
  const [messages, setMessages] = useState([]);
  const [activeChatEmail, setActiveChatEmail] = useState(null);
  const [self, setSelf] = useState(null);
  const [unreadCounts, setUnreadCounts] = useState({});

  const selfRef = useRef(null);
  const activeChatEmailRef = useRef(null);

  useEffect(() => {
    selfRef.current = self;
  }, [self]);

  useEffect(() => {
    activeChatEmailRef.current = activeChatEmail;
  }, [activeChatEmail]);

  useEffect(() => {
    const fetchMessages = async () => {
      const res = await fetch('/messages') ;
      const data = await res.json();
      setMessages(data);
    };

    fetchMessages();

    socket.on('user list', (userList) => {
      setUsers(userList);
      const myEmail = socket.io.opts.query.email;
      const me = userList.find(u => u.email === myEmail);
      console.log("myEmail", myEmail);
      console.log("self resolved from user list", me);
      setSelf(me || null);
    });

    socket.on('chat message', (msg) => {
      setMessages(prev => [...prev, msg]);

      const isGeneral = msg.toEmail === null;
      const isCurrentChat =
        (isGeneral && activeChatEmailRef.current === null) ||
        (msg.fromEmail === activeChatEmailRef.current || msg.toEmail === activeChatEmailRef.current);

      const isToMe = msg.toEmail === selfRef.current?.email || msg.toEmail === null;

      if (!isCurrentChat && isToMe) {
        const key = msg.toEmail === null ? 'general' : (msg.fromEmail === selfRef.current?.email ? msg.toEmail : msg.fromEmail);
        setUnreadCounts(prev => ({
          ...prev,
          [key]: (prev[key] || 0) + 1,
        }));
      }
    });

    socket.on('reaction updated', ({ messageId, reactions }) => {
      setMessages(prev =>
        prev.map(m =>
          m._id === messageId ? { ...m, reactions } : m
        )
      );
    });

    return () => {
      socket.off('user list');
      socket.off('chat message');
      socket.off('reaction updated');
    };
  }, []);

  useEffect(() => {
    // Reload messages when switching between chats
    fetch('/messages')
      .then(res => res.json())
      .then(data => {
        setMessages(data);
      });
  }, [activeChatEmail]);

  useEffect(() => {
    const key = activeChatEmail === null ? 'general' : activeChatEmail;
    setUnreadCounts(prev => ({ ...prev, [key]: 0 }));
  }, [activeChatEmail]);

  const relevantMessages = messages.filter(
    m => (activeChatEmail === null && m.toEmail === null) ||
         (m.toEmail === self?.email && m.fromEmail === activeChatEmail) ||
         (m.fromEmail === self?.email && m.toEmail === activeChatEmail)
  );

  return (
    <div className="chat-container">
      <ChatSidebar
        users={users}
        self={self}
        activeChatEmail={activeChatEmail}
        onSelect={setActiveChatEmail}
        unreadCounts={unreadCounts}
      />
      <ChatWindow
        self={self}
        activeChatEmail={activeChatEmail}
        messages={relevantMessages}
      />
    </div>
  );
};

export default App;
